module.exports = __webpack_public_path__ + "img/slider1-3.a45bcc38.png";